export default {
  navigationBarTitleText: '选择素材'
};
